export default __webpack_public_path__ + "static/media/banner.f87c4e3b.svg";